import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  message: string;
  pending?: boolean;
};

export function UnusualAmountConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  message,
  pending,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Monto inusualmente alto</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>

        <p className="text-app-ink-2 text-sm">
          ¿Confirmar el costo de todos modos? Si se trata de un error de tipeo, cancelá y revisá el
          monto.
        </p>

        <DialogFooter>
          <button
            type="button"
            disabled={pending}
            onClick={() => onOpenChange(false)}
            className="inline-flex h-10 items-center justify-center rounded-xl border border-app-border bg-app-surface px-4 font-medium text-[14px] text-app-ink-1 transition-colors hover:bg-app-surface-2 disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={pending}
            onClick={onConfirm}
            className="inline-flex h-10 items-center justify-center rounded-xl bg-app-ink-1 px-4 font-medium text-[14px] text-white transition-colors hover:bg-[#1e211d] disabled:opacity-50"
          >
            {pending ? "Confirmando…" : "Sí, confirmar"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
